module.exports = __webpack_public_path__ + "static/img/logo2.2776eb3c.png";